import { FadeIn } from "../ui/FadeIn";
import { PhoneMockup } from "../ui/PhoneMockup";

function HomeMockup() {
  return (
    <img src="/rada-10-07.svg" alt="Vista de asistentes en home" className="w-full rounded-xl" />
  );
}

function PerfilesMockup() {
  return (
    <img
      src="/agente_pela-07.svg"
      alt="Vista de asistentes en perfiles"
      className="w-full rounded-xl"
    />
  );
}

function ChatMockup() {
  return (
    <img
      src="/asistentes-chat.svg"
      alt="Vista de chat con asistentes"
      className="w-full rounded-xl"
    />
  );
}

export function FeaturesSection() {
  return (
    <section className="py-16 sm:py-24">
      <div className="section-shell">
        <FadeIn className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-bold sm:text-4xl">¿Dónde los encuentro?</h2>
          <p className="mt-4 text-base text-ink sm:text-lg">
            ¡Están en el Radar de la app! Ingresando a sus perfiles, podés acceder a tips y
            contenidos o iniciar chats para hablar directamente con cada uno.
          </p>
        </FadeIn>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <FadeIn delay={0.05}>
            <PhoneMockup title="RADAR +10">
              <HomeMockup />
            </PhoneMockup>
          </FadeIn>
          <FadeIn delay={0.1}>
            <PhoneMockup title="PERFILES">
              <PerfilesMockup />
            </PhoneMockup>
          </FadeIn>
          <FadeIn delay={0.15}>
            <PhoneMockup title="CHAT">
              <ChatMockup />
            </PhoneMockup>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
